import queryString from 'query-string';
import useRouter from 'use-react-router';
import { useMemo } from 'react';

export default function useQueryParams() {
  const { location } = useRouter();

  return useMemo(() => queryString.parse(location.search.slice(1)), [location.search]) || {};
}
